import { Shield } from 'lucide-react';
import { type ReactElement } from 'react';
import { type SapaMessageItemType } from 'types/sapa';
import { MessageTypes } from '../types';
import SapaMessage from './SapaMessage';

interface SystemMessageProps {
  message: SapaMessageItemType;
}

const SystemMessage = ({ message }: SystemMessageProps): ReactElement => {
  const { type, questionId } = message;
  const Component = MessageTypes[type];

  return (
    <div key={message.id} className="mb-4">
      <div className="flex items-start gap-2">
        <div className="h-8 w-8 rounded-full bg-red-600 flex items-center justify-center shrink-0">
          <Shield className="h-4 w-4 text-white" />
        </div>
        <SapaMessage>
          <div className="whitespace-pre-line">{message.content}</div>
          {Component && questionId && <Component message={message} questionId={questionId} />}
        </SapaMessage>
      </div>
    </div>
  );
};

export default SystemMessage;
